import * as types from './actionTypes';
import Resource from "../services/Resource";
import FormDataFormatter from "../services/FormDataFormatter";
import {toastrErrorHandler} from "./utils";
import PrivateAPIResource from "../services/PrivateAPIResource";

export function loadContactPersonsSuccess(contactPersons) {
    return {type: types.LOAD_CONTACT_PERSONS_SUCCESS, contactPersons};
}

export function createContactPersonSuccess(contactPerson) {
    return {type: types.CREATE_CONTACT_PERSON_SUCCESS, contactPerson};
}

export function createContactPersonError(error) {
    return {type: types.CREATE_CONTACT_PERSON_ERROR, error};
}

export function updateContactPersonSuccess(contactPerson) {
    return {type: types.UPDATE_CONTACT_PERSON_SUCCESS, contactPerson};
}

export function cloneContactPersonSuccess(contactPerson) {
    return {type: types.CLONE_CONTACT_PERSON_SUCCESS, contactPerson};
}

export function deleteContactPersonSuccess(id) {
    return {type: types.DELETE_CONTACT_PERSON_SUCCESS, id};
}

export function loadContactPersons(id, sortParams) {
    return function (dispatch) {
        let contactPersons = PrivateAPIResource.getNested('companies', 'users', id, sortParams);
        return contactPersons.then(contactPersons => {
            dispatch(loadContactPersonsSuccess(contactPersons))
        }).catch(error => {
            throw  error;
        });
    }
}

export function createContactPerson(contactPerson) {
    return function (dispatch) {
        contactPerson = FormDataFormatter.getFormData(contactPerson);
        let promise = PrivateAPIResource.create('users', contactPerson, true);
        return promise.then(contactPerson => {
            dispatch(createContactPersonSuccess(contactPerson))
        }).catch(toastrErrorHandler);
    }
}

export function updateContactPerson(contactPerson) {
    return function (dispatch) {
        const contactPersonId = contactPerson.id;
        contactPerson = FormDataFormatter.getFormData(contactPerson);
        let promise = PrivateAPIResource.update('users', contactPersonId, contactPerson, true);
        return promise.then(contactPerson => {
            dispatch(updateContactPersonSuccess(contactPerson))
        }).catch(toastrErrorHandler);
    }
}

export function cloneContactPerson(id) {
    return function (dispatch) {
        return PrivateAPIResource.clone('users', id).then(contactPerson => {
            dispatch(cloneContactPersonSuccess(contactPerson))
        }).catch(error => {
            throw  error;
        });
    }
}

export function deleteContactPerson(id) {
    return function (dispatch) {
        return PrivateAPIResource.remove('users', id).then(() => {
            dispatch(deleteContactPersonSuccess(id));
        }).catch(error => {
            throw error;
        });
    }
}

export function showContactPersonDeleteModal() {
    return {type: types.SHOW_CONTACT_PERSON_DELETE_MODAL, status: true};
}

export function hideContactPersonDeleteModal() {
    return {type: types.HIDE_CONTACT_PERSON_DELETE_MODAL, status: false};
}


// WEBPACK FOOTER //
// ./web/src/actions/contactPersonListActions.js